import React, { memo } from 'react';
import { Footer } from '../components/Footer';
import { Feather, Heart, BookOpen, Brain, Handshake, Globe, Target, Building, Ear } from 'lucide-react';
export const AboutUs = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-494" data-mp="3drcltnhlkkgp">
      <main className="relative flex-grow overflow-hidden" data-id="element-495" data-mp="3doqhrxtx0n38">
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-496" data-mp="3iow2eu1rp9bt" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -top-[200px] left-1/3 w-[1200px] h-[1200px] bg-gradient-to-br from-cyan-400/20 via-cyan-300/15 to-primary-200/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10" data-id="element-497" data-mp="34pd7j2xyvuhg" />
        {/* Hero section */}
        <section className="w-full pt-16 pb-10 md:pt-20 md:pb-14 relative overflow-hidden" data-id="element-498" data-mp="2uttagd7o2pr4">
          <div className="absolute top-0 right-1/4 w-[900px] h-[900px] bg-gradient-to-br from-cyan-700/10 via-teal-500/20 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-499" data-mp="2zrlc3yy45q8i" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-500" data-mp="xydq66nzwadn">
            <div className="max-w-4xl mx-auto" data-id="element-501" data-mp="2funt41bqlflk">
              <div className="flex flex-col md:flex-row items-center gap-4 mb-6 justify-center p-0" data-id="element-502" data-mp="2ftcpq2m7e9uz">
                <h1 className="text-4xl md:text-4xl font-serif font-normal text-cyan-900 text-center md:text-left pt-6" data-id="element-503" data-mp="2avb71isowck1">
                  About the Nisa Team
                </h1>
                <div className="md:w-auto flex justify-center" data-id="element-504" data-mp="2kmp2nfhiss7w">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iT3rTW2gA8gm9VBU9nHsNk/Nisa_-_Plant_Arc_Growth.png" alt="Plant growth illustration" className="w-full max-w-[150px]" data-id="element-505" data-mp="1wvrzos7pd58s" />
                </div>
              </div>
              <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-506" data-mp="25xsznwubm5e5">
                <p className="text-xl font-medium mb-6 text-center" data-id="element-507" data-mp="20x589a26jmje">
                  We believe great instruction is a right, not a privilege.
                </p>
                <p className="mb-6 text-lg pb-5 mx-auto" style={{
                width: 'calc(80% + 40px)'
              }} data-id="element-508" data-mp="3hdzlztpj9yr3">
                  We're building tools that support the people who make that
                  possible every day: instructional coaches and the teachers
                  they partner with. Whether it's helping a coach prepare a
                  planning session, supporting a teacher as they refine their
                  lesson, or capturing insights from classroom practice, Nisa is
                  designed to show up quietly and helpfully—just when it's
                  needed.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Mission image moved here, above Why Nisa section */}
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-509" data-mp="208szha0k56kb">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a6oMit83Uh87AeL1tTsyKz/image.png" alt="Our Mission: Reduce the mental overhead of coaching and teaching, so educators can focus on what matters most: great instruction and thriving classrooms." className="w-full rounded-lg shadow-sm" data-id="element-510" data-mp="250165yai6dts" />
        </div>
        {/* Why Nisa section */}
        <section className="w-full py-section-mobile relative overflow-hidden bg-gradient-to-br from-white via-primary-50/30 to-blue-50/30" data-id="element-511" data-mp="14zz22jh1jkf4">
          <div className="absolute bottom-0 left-1/4 w-[800px] h-[800px] bg-gradient-to-tr from-teal-400/20 via-cyan-400/10 to-sky-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10" data-id="element-512" data-mp="v2b5dnzvk2ub" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-513" data-mp="r2sm0wnpbztl">
            <div className="max-w-4xl mx-auto" data-id="element-514" data-mp="m2odbst1c9dx">
              <div className="flex items-center justify-center mb-8" data-id="element-515" data-mp="m3fxm7h6mkow">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-516" data-mp="h9lk5ls671y9">
                  Why "Nisa"?
                </h2>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-517" data-mp="7di7vn3ltmxl">
                <p className="mb-6 text-gray-700" data-id="element-518" data-mp="3a3p4ooa6sgg">
                  The name "Nisa" is inspired by Nisaba, the ancient Sumerian
                  goddess of learning, writing, and memory. She was believed to
                  hold humanity's story—tracking its unfolding through careful
                  inscription. That same spirit lives in our work.
                </p>
                <p className="mb-6 text-gray-700" data-id="element-519" data-mp="1ooqnz14a0k3u">How Nisa helps educators:</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-520" data-mp="1omnu260066tu">
                  <div className="bg-gradient-to-br from-sky-100 to-sky-200/90 rounded-lg p-4 border border-sky-300/60 hover:shadow-md transition-shadow" data-id="element-521" data-mp="1tlqokwicwunk">
                    <div className="flex flex-col items-center text-center" data-id="element-522" data-mp="1jpnpy0mpre5d">
                      <div className="bg-gradient-to-br from-sky-200 to-sky-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-523" data-mp="15pw79ml959l1">
                        <BookOpen className="w-5 h-5 text-sky-700" data-id="element-524" data-mp="1anxpk5aut4vg" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-525" data-mp="303dwde1b2ei6">
                        Capture what matters
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-indigo-100 to-blue-200/90 rounded-lg p-4 border border-indigo-300/60 hover:shadow-md transition-shadow" data-id="element-526" data-mp="3f65kwetcg02m">
                    <div className="flex flex-col items-center text-center" data-id="element-527" data-mp="3a5hlp5uyocxb">
                      <div className="bg-gradient-to-br from-indigo-200 to-blue-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-528" data-mp="3o0jwo7eo0sgz">
                        <Target className="w-5 h-5 text-indigo-700" data-id="element-529" data-mp="3j661o63x0ncu" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-530" data-mp="1tvg95rtca8h">
                        Plan with purpose
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-purple-100 to-fuchsia-200/90 rounded-lg p-4 border border-purple-300/60 hover:shadow-md transition-shadow" data-id="element-531" data-mp="arnx4ed6npxz">
                    <div className="flex flex-col items-center text-center" data-id="element-532" data-mp="2ckvavjd5dzhr">
                      <div className="bg-gradient-to-br from-purple-200 to-fuchsia-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-533" data-mp="28ii8n4xm0jpq">
                        <Building className="w-5 h-5 text-purple-700" data-id="element-534" data-mp="binppfficzf2" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-535" data-mp="ghqju4ty9l89">
                        Build conditions for excellent, equitable teaching
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700" data-id="element-536" data-mp="qcs9r2w1urbw">
                  Like Nisaba, we honor the knowledge that lives in classrooms.
                  We see educators not just as implementers of curriculum, but
                  as authors of progress. Nisa is here to support their wisdom,
                  not replace it.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Our Values section */}
        <section className="w-full py-section-mobile relative overflow-hidden" data-id="element-537" data-mp="1e58rtdfsejb7">
          <div className="absolute top-1/3 right-0 w-[700px] h-[700px] bg-gradient-to-br from-sky-400/10 via-cyan-400/10 to-teal-400/20 rounded-[45%_55%_50%_50%] blur-3xl -z-10" data-id="element-538" data-mp="1i5rlze55k1gk" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-539" data-mp="32lqsi33klep5">
            <div className="max-w-4xl mx-auto" data-id="element-540" data-mp="2ylp1qozdi5on">
              <div className="flex items-center justify-center mb-8" data-id="element-541" data-mp="2tndrwe92vv6f">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-542" data-mp="2tnnh3zmatyb2">
                  Our Values
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-543" data-mp="3mccb7eoxt3db">
                <div className="bg-cyan-100/80 rounded-lg p-6 border border-cyan-200/60 hover:shadow-sm transition-shadow" data-id="element-544" data-mp="3hczrv3x9yefh">
                  <div className="flex items-start" data-id="element-545" data-mp="3clhlu1ge9nnn">
                    <div className="bg-cyan-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-546" data-mp="3cjws2e1wm8qu">
                      <Ear className="w-7 h-7 text-white" data-id="element-547" data-mp="37mwny8om7g2d" />
                    </div>
                    <div data-id="element-548" data-mp="8yr366xvi7sl">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-549" data-mp="8yzg1ytzxd3s">
                        Listen deeply
                      </h3>
                      <p className="text-gray-700" data-id="element-550" data-mp="38o0sevmd2omh">
                        We center the lived experiences of educators. Their
                        voice shapes everything we build.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-teal-100/80 rounded-lg p-6 border border-teal-200/60 hover:shadow-sm transition-shadow" data-id="element-551" data-mp="33owjm63cmswo">
                  <div className="flex items-start" data-id="element-552" data-mp="3rftmktd62fvs">
                    <div className="bg-teal-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-553" data-mp="3rcxqzbosk3ai">
                      <Brain className="w-7 h-7 text-white" data-id="element-554" data-mp="6d1vxiar5g4" />
                    </div>
                    <div data-id="element-555" data-mp="3idsqw0xl01w8">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-556" data-mp="3igf0s77y2thm">
                        Reduce cognitive load
                      </h3>
                      <p className="text-gray-700" data-id="element-557" data-mp="26y43j8gf10uw">
                        Teaching and coaching are complex. We strive to bring
                        clarity, not clutter.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-sky-100/80 rounded-lg p-6 border border-sky-200/60 hover:shadow-sm transition-shadow" data-id="element-558" data-mp="1zfxjhipl2wjn">
                  <div className="flex items-start" data-id="element-559" data-mp="2de4aqg011yac">
                    <div className="bg-sky-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-560" data-mp="28g2r9tyovwyc">
                      <Handshake className="w-7 h-7 text-white" data-id="element-561" data-mp="28dzpyds36heb" />
                    </div>
                    <div data-id="element-562" data-mp="1kqrqichca2k7">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-563" data-mp="1frf41sudqxi5">
                        Partner with purpose
                      </h3>
                      <p className="text-gray-700" data-id="element-564" data-mp="1uh30afnpf5z0">
                        We don't chase trends. We build tools that integrate
                        into real workflows and support lasting change.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-primary-100/80 rounded-lg p-6 border border-primary-200/60 hover:shadow-sm transition-shadow" data-id="element-565" data-mp="x04ebf0e4qru">
                  <div className="flex items-start" data-id="element-566" data-mp="1sicnon5czd7s">
                    <div className="bg-primary-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-567" data-mp="1nmdv0nczz91k">
                      <Globe className="w-7 h-7 text-white" data-id="element-568" data-mp="1ilgfkijdgt3r" />
                    </div>
                    <div data-id="element-569" data-mp="1dnetdoqngdo2">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-570" data-mp="1dm4xn679rhkl">
                        Equity as a design principle
                      </h3>
                      <p className="text-gray-700" data-id="element-571" data-mp="14uuuqoacy938">
                        We believe every student deserves access to excellent
                        instruction—and every educator deserves tools that
                        support that mission.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Who We Are section */}
        <section className="w-full py-section-mobile pb-16 relative overflow-hidden bg-gradient-to-br from-white via-primary-50/30 to-blue-50/30" data-id="element-572" data-mp="lxa359g7kwex">
          <div className="absolute bottom-1/3 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-teal-400/20 via-cyan-300/10 to-emerald-400/10 rounded-[55%_45%_40%_60%] blur-3xl -z-10" data-id="element-573" data-mp="31kxgzj9ookq8" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-574" data-mp="36i7hpv2iwitd">
            <div className="max-w-4xl mx-auto" data-id="element-575" data-mp="3bhshg7piov75">
              <div className="flex items-center justify-center mb-8" data-id="element-576" data-mp="2dvczz5x3bxjl">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-577" data-mp="2dx65ghvywbq0">
                  Who We Are
                </h2>
              </div>
              <div className="bg-gradient-to-r from-cyan-100/25 to-teal-200/25 backdrop-blur-sm rounded-xl p-5 shadow-sm border border-gray-100 flex flex-col md:flex-row items-center" data-id="element-578" data-mp="2nt95ni79e0ab">
                <div className="md:w-auto flex-shrink-0" data-id="element-579" data-mp="1v5ddmqsmwwjv">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pfwRrB6KfuFaW7KfrpbYwz/Nisa_Duo_Orange.png" alt="Nisa team illustration" className="w-full max-w-[224px]" data-id="element-580" data-mp="1v2r8ext7ut4t" />
                </div>
                <div className="md:flex-1" data-id="element-581" data-mp="1s15zdkfdu91w">
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-582" data-mp="1o2gktoilylgo">
                    We're a team of educators and technologists committed to
                    reimagining the tools educators use every day. We've taught
                    in classrooms, led school teams, coached teachers, and built
                    edtech products. Now we're building something better for the
                    people we've worked alongside and the communities they
                    serve.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-583" data-mp="1e2prvr9p4eip" />
    </div>;
};